import {
  AccountPageDataDto,
  AccountPreviewDto,
  AccountsQueryOptions,
  AccountStatusDto,
  PaginatedQueryOptions,
  PaginatedResponse,
} from '@brage/dto';
import {AxiosInstance} from 'axios';

export function accountFetchers(client: AxiosInstance) {
  return {
    getAccount: ({orgNo, accountNo}: {orgNo: string | null; accountNo: string}) => {
      const url = orgNo ? `/${orgNo}/accounts/${accountNo}` : `/accounts/${accountNo}`;
      return client.get<AccountPageDataDto>(url).then((r) => r.data);
    },
    getAccountStatus: ({orgNo, accountNo}: {orgNo: string | null; accountNo: string}) => {
      const url = orgNo
        ? `/${orgNo}/accounts/${accountNo}/status`
        : `/accounts/${accountNo}/status`;
      return client.get<AccountStatusDto>(url).then((r) => r.data);
    },
    getAccounts: ({
      orgNo,
      active,
    }: {
      orgNo: string | null;
      active: boolean;
    }): Promise<PaginatedResponse<AccountPreviewDto>> => {
      const url = orgNo ? `/${orgNo}/accounts` : '/accounts';
      return client
        .get<PaginatedResponse<AccountPreviewDto>>(url, {
          params: {active: active},
        })
        .then((r) => r.data);
    },
    getPaginatedAccounts:
      ({
        orgNo,
        active,
        filterOptions,
      }: {
        orgNo: string | null;
        active: boolean;
        filterOptions?: AccountsQueryOptions;
      }) =>
      (opts: PaginatedQueryOptions): Promise<PaginatedResponse<AccountPreviewDto>> => {
        const url = orgNo ? `/${orgNo}/accounts` : '/accounts';
        // Strip undefined values so they aren't sent as "undefined" strings in query params
        const cleanFilterOptions = filterOptions
          ? Object.fromEntries(
              Object.entries(filterOptions)
                .filter(([, v]) => v !== undefined && v !== '')
                .map(([k, v]) => [k, Array.isArray(v) ? v.join(',') : v]),
            )
          : {};
        return client
          .get<PaginatedResponse<AccountPreviewDto>>(url, {
            params: {
              skip: opts.skip,
              take: opts.take,
              active: active,
              ...cleanFilterOptions,
            },
          })
          .then((r) => r.data);
      },
    getAllAccounts: ({
      orgNo,
      active,
      filterOptions,
    }: {
      orgNo: string | null;
      active: boolean;
      filterOptions?: AccountsQueryOptions;
    }): Promise<AccountPreviewDto[]> => {
      const url = orgNo ? `/${orgNo}/accounts` : '/accounts';
      const cleanFilterOptions = filterOptions
        ? Object.fromEntries(
            Object.entries(filterOptions)
              .filter(([, v]) => v !== undefined && v !== '')
              .map(([k, v]) => [k, Array.isArray(v) ? v.join(',') : v]),
          )
        : {};
      return client
        .get<PaginatedResponse<AccountPreviewDto>>(url, {
          params: {
            skip: 0,
            take: 0,
            active: active,
            ...cleanFilterOptions,
          },
        })
        .then((r) => r.data.data);
    },
    getAccountsBuyoutDisabled: (orgNo: string | null) => {
      if (!orgNo) {
        return Promise.resolve(true);
      }
      const url = `/${orgNo}/accounts/buyout-disabled`;
      return client.get<boolean>(url).then((r) => r.data);
    },
  };
}
